import { useEffect, useState } from "react";
import { detectPlatform, resolveShell } from "@ect/core";
import { SessionProvider, useSession } from "./app/session";
import { SyncProvider } from "./app/powersync";
import { NotificationsBootstrap } from "./app/notifications-os";
import { Login } from "./screens/Login";
import { FieldHome } from "./screens/FieldHome";
import { AdminDesktop, AdminMobile } from "./screens/AdminHome";
import { PinGate } from "./screens/PinLock";

function useViewportWidth() {
  const [w, setW] = useState(() => (typeof window === "undefined" ? 1280 : window.innerWidth));
  useEffect(() => {
    const on = () => setW(window.innerWidth);
    window.addEventListener("resize", on);
    return () => window.removeEventListener("resize", on);
  }, []);
  return w;
}

function Shell() {
  const { session, ready, role } = useSession();
  const width = useViewportWidth();
  if (!ready) return null;
  if (!session) return <Login />;
  const shell = resolveShell({ platform: detectPlatform(), viewportWidth: width, role });
  return (
    <PinGate key={session.user.id}>
      <SyncProvider>
        <NotificationsBootstrap />
        {shell === "desktop_admin" ? <AdminDesktop /> : shell === "mobile_admin" ? <AdminMobile /> : <FieldHome />}
      </SyncProvider>
    </PinGate>
  );
}

export function App() {
  return (
    <SessionProvider>
      <Shell />
    </SessionProvider>
  );
}
